import React, { useState, useRef } from "react";
import { motion } from "framer-motion";
import { Play, Pause, Volume2, VolumeX } from "lucide-react";

const SHOP_VIDEO_URL = "https://customer-assets.emergentagent.com/job_sri-paint-studio/artifacts/hs5lgyue_WhatsApp%20Video%202026-02-02%20at%2023.06.21.mp4";
const POSTER_IMAGE = "https://images.unsplash.com/photo-1758972581344-85dd3ccb10db?crop=entropy&cs=srgb&fm=jpg&q=85&w=800";

export const GallerySection = () => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [isMuted, setIsMuted] = useState(true);
  const videoRef = useRef(null);

  const togglePlay = () => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
      } else {
        videoRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  const toggleMute = () => {
    if (videoRef.current) {
      videoRef.current.muted = !isMuted;
      setIsMuted(!isMuted);
    }
  };

  return (
    <section id="gallery" className="py-16 sm:py-20 lg:py-28 bg-gray-900" data-testid="gallery-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
        <div className="text-center mb-10 sm:mb-14">
          <span className="text-purple-400 font-semibold tracking-wider uppercase text-xs sm:text-sm">Our Shop</span>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white mt-2 sm:mt-3">
            Visit Our <span className="text-purple-400">Showroom</span>
          </h2>
          <p className="text-gray-400 mt-3 text-sm sm:text-base">Take a virtual tour of Sri Pavanasutha Traders</p>
        </div>

        <motion.div 
          initial={{ opacity: 0, scale: 0.98 }} 
          whileInView={{ opacity: 1, scale: 1 }} 
          viewport={{ once: true }} 
          className="video-container relative max-w-3xl mx-auto"
        >
          <video 
            ref={videoRef} 
            src={SHOP_VIDEO_URL} 
            className="w-full rounded-xl sm:rounded-2xl" 
            playsInline 
            muted={isMuted} 
            loop 
            poster={POSTER_IMAGE} 
            data-testid="shop-video" 
          />
          
          <div className="absolute bottom-3 sm:bottom-4 left-3 sm:left-4 right-3 sm:right-4 flex justify-between items-center z-50">
            <button 
              onClick={togglePlay} 
              className="w-11 h-11 sm:w-14 sm:h-14 bg-white/90 backdrop-blur-sm rounded-full flex items-center justify-center shadow-lg hover:scale-105 transition-transform" 
              data-testid="video-play-button"
            >
              {isPlaying ? <Pause className="w-5 h-5 sm:w-6 sm:h-6 text-gray-900" /> : <Play className="w-5 h-5 sm:w-6 sm:h-6 text-gray-900 ml-0.5" />}
            </button>
            <button 
              onClick={toggleMute} 
              className="w-10 h-10 sm:w-12 sm:h-12 bg-white/90 backdrop-blur-sm rounded-full flex items-center justify-center shadow-lg hover:scale-105 transition-transform" 
              data-testid="video-mute-button"
            >
              {isMuted ? <VolumeX className="w-4 h-4 sm:w-5 sm:h-5 text-gray-900" /> : <Volume2 className="w-4 h-4 sm:w-5 sm:h-5 text-gray-900" />}
            </button>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
